import { LeadHistoryType, SalesStage } from '../Model/Lead';

const SalesStageWorkFlow = [
  SalesStage.NEW_LEAD,
  SalesStage.INVALID_CONTACT,
  SalesStage.FIRST_MESSAGE,
  SalesStage.SECOND_MESSAGE,
  SalesStage.CALENDLY_SCHEDULED,
];

const getNextSalesStage = (currentSalesStage) => {
  const currentIndex = SalesStageWorkFlow.indexOf(currentSalesStage);
  if (currentIndex >= 0 && currentIndex < SalesStageWorkFlow.length - 1) {
    return SalesStageWorkFlow[currentIndex + 1];
  }
  return null;
};

const rescheduleViaSDR = async (leadDoc, reason, userId, userName) => {
  // Add a new entry to the lead history, so that we can track who sent the lead back to SDR
  await leadDoc.addItemToHistory({
    value: { reason },
    reason,
    createdAt: new Date(),
    activityType: LeadHistoryType.SENT_TO_RESCHEDULE,
    createdBy: userId,
    createdByUserName: userName,
  });

  // The lead will be back IN_DIALOGUE.
  await leadDoc.setSalesStage(SalesStage.IN_DIALOGUE, { userId, userName });
};

export {
  SalesStageWorkFlow,
  getNextSalesStage,
  rescheduleViaSDR,
};
